export const DICTIONARIES_IN_API = {
	ALL: "WL", // Look in all dictionaries
	BIG: "BIG", // World's Biggest Crossword
	BRAIN: "BRAIN", // Word Brain
	CHU: "CHU", // Word Chums
	CONNECT: "CONNECT", // Word Connect
	COOKIES: "COOKIES", // Word Cookies
	CROSS: "CROSS", // CodyCross
	CROSSY: "CROSSY", // Word Crossy
	CWF: "CWF", // Crossword with Friends
	DOM: "DOM", // Word Domination
	FEU: "FEU", // Wordfeud
	HQ: "HQ", // HQ
	JOURNEY: "JOURNEY", // Word Journey
	JUM: "JUM", // Just Jumble
	NYTC: "NYTC", // NY Times Crossword
	NYTS: "NYTS", // NY Times Spelling
	PICS: "PICS", // 4 Pics 1 Word
	PICTO: "PICTO", // Pictoword
	STORY: "STORY", // Words Story
	SWIPE: "SWIPE", // Word Swipe
	TRIP: "TRIP", // Word Trip
	TWIST: "TWIST", // Text Twist
	US: "US", // Scrabble US
	UK: "UK", // Scrabble UK
	WWF: "WWF", // Words With Friends
	YDR: "YDR", // YDR definition available
	ANAGRAM: "ANAGRAM", // YDR definition available
	WORDLE: "WORDLE", // Wordle
	WORDLE_ALL: "WORDLE_ALL", // Wordle (all playable words, not only for nyt wordle)
	WS: "SCAPE", // Wordscapes
};

export const DICTIONARY_LISTS = {
	SCRABBLE_ONLY: [DICTIONARIES_IN_API.US, DICTIONARIES_IN_API.UK],
	DEFAULT: [
		DICTIONARIES_IN_API.WWF,
		DICTIONARIES_IN_API.US,
		DICTIONARIES_IN_API.UK,
		DICTIONARIES_IN_API.WS,
		DICTIONARIES_IN_API.ANAGRAM,
		DICTIONARIES_IN_API.PICS,
		DICTIONARIES_IN_API.JUM,
		DICTIONARIES_IN_API.CONNECT,
		DICTIONARIES_IN_API.COOKIES,
		DICTIONARIES_IN_API.CHU,
		DICTIONARIES_IN_API.TWIST,
		DICTIONARIES_IN_API.CROSS,
		DICTIONARIES_IN_API.FEU,
		DICTIONARIES_IN_API.BRAIN,
		DICTIONARIES_IN_API.STORY,
		DICTIONARIES_IN_API.SWIPE,
		DICTIONARIES_IN_API.ALL,
	],
};

// Note this uses the name of keys and not the value of the keys!
// This allows us to not worry about any of the dictionaries
// changing its value.
const GAME_ICON_POSITION_IN_SPRITE = {
	WWF: 2,
	US: 1,
	UK: 1,
	WS: 16,
	ANAGRAM: 3,
	PICS: 4,
	JUM: 5,
	CONNECT: 7,
	COOKIES: 6,
	CHU: 8,
	TWIST: 9,
	CROSS: 10,
	FEU: 11,
	BRAIN: 12,
	STORY: 13,
	SWIPE: 14,
	ALL: 15,
};

// Used for the top right corner button on mobile
export const GAME_ICONS_SPRITE_META_SMALLER_ICONS = {
	offsetY: 11,
	iconHeight: 24,
	position: GAME_ICON_POSITION_IN_SPRITE,
};

// Used for the dropdowns on desktop
export const GAME_ICONS_SPRITE_META_SMALL_ICONS = {
	offsetY: 12,
	iconHeight: 26,
	position: GAME_ICON_POSITION_IN_SPRITE,
};

// Used for the list shown on mobile devices
export const GAME_ICONS_SPRITE_META_BIG_ICONS = {
	offsetY: 26,
	iconHeight: 58,
	position: GAME_ICON_POSITION_IN_SPRITE,
};
